import React from "react";
import python_img from "../../../assets/images/python_img.jpg";
import { Link } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import { FREELANCER } from "../../../Router/paths";

function CoursesBoxes({ courses, handleFilterChange }) {
  return (
    <div className="course-sec pc-p-6">
      <div className="container">
        <div className="primary-heading color-dark text-center">
          <h3 className="color-primary">Let's Start Learning</h3>
        </div>
        <div className="courses-search mb-5">
          <div className="course-search-form mt-4">
            <input
              type="search"
              className="form-control"
              onChange={handleFilterChange}
              placeholder="Search..."
            />
            <button>
              <FaSearch />
            </button>
          </div>
        </div>
        <div className="row justify-content-center">
          {!courses.length && <h1>No Course Found!</h1>}
          {courses?.map((e) => (
            <div className="col-lg-3" key={e.id}>
              <div className="course-box">
                <div className="course-img">
                  <img src={python_img} alt="Python" />
                </div>
                <div className="course-box-content">
                  {/* <h5>Technalogy</h5> */}
                  <h4 className="text-capitalize">
                    <Link to={FREELANCER.viewCourse(e.id)}> {e.title} </Link>
                  </h4>
                  <div className="progress">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{
                        width: `${e?.progress_percent}%`,
                        ariaValuenow: e?.progress_percent,
                        ariaValuemin: 0,
                        ariaValuemax: 100,
                      }}
                    >
                      {e?.progress_percent.toFixed(1)}%
                    </div>
                  </div>
                  <div className="course-hour-box mt-1">
                    <span>
                      <i className="fa fa-clock"></i> {e?.total_duration} Hour
                    </span>
                    <span>
                      <i className="fa fa-wifi"></i> {e?.level}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
          {/* <div className="col-lg-3">
                    <div className="course-box">
                        <div className="course-img">
                            <img src={python_img} alt="Python Image" />
                        </div>
                        <div className="course-box-content">
                            <h5>Technology</h5>
                            <h4><Link to="/coursesdetailpage"> Basics of Python </Link></h4>
                            <div className="course-hour-box">
                                <span><i className="fa fa-clock"></i> 1 Hour</span>
                                <span><i className="fa fa-wifi"></i> Beginner</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3">
                    <div className="course-box">
                        <div className="course-img">
                            <img src={python_img} alt="Python Image" />
                        </div>
                        <div className="course-box-content">
                            <h5>Technology</h5>
                            <h4><Link to="/coursesdetailpage"> Basics of Python </Link></h4>
                            <div className="course-hour-box">
                                <span><i className="fa fa-clock"></i> 1 Hour</span>
                                <span><i className="fa fa-wifi"></i> Beginner</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3">
                    <div className="course-box">
                        <div className="course-img">
                            <img src={python_img} alt="Python Image" />
                        </div>
                        <div className="course-box-content">
                            <h5>Technology</h5>
                            <h4><Link to="/coursesdetailpage"> Basics of Python </Link></h4>
                            <div className="course-hour-box">
                                <span><i className="fa fa-clock"></i> 1 Hour</span>
                                <span><i className="fa fa-wifi"></i> Beginner</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3">
                    <div className="course-box">
                        <div className="course-img">
                            <img src={python_img} alt="Python Image" />
                        </div>
                        <div className="course-box-content">
                            <h5>Technology</h5>
                            <h4><Link to="/coursesdetailpage"> Basics of Python </Link></h4>
                            <div className="course-hour-box">
                                <span><i className="fa fa-clock"></i> 1 Hour</span>
                                <span><i className="fa fa-wifi"></i> Beginner</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3">
                    <div className="course-box">
                        <div className="course-img">
                            <img src={python_img} alt="Python Image" />
                        </div>
                        <div className="course-box-content">
                            <h5>Technology</h5>
                            <h4><Link to="/coursesdetailpage"> Basics of Python </Link></h4>
                            <div className="course-hour-box">
                                <span><i className="fa fa-clock"></i> 1 Hour</span>
                                <span><i className="fa fa-wifi"></i> Beginner</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3">
                    <div className="course-box">
                        <div className="course-img">
                            <img src={python_img} alt="Python Image" />
                        </div>
                        <div className="course-box-content">
                            <h5>Technology</h5>
                            <h4><Link to="/coursesdetailpage"> Basics of Python </Link></h4>
                            <div className="course-hour-box">
                                <span><i className="fa fa-clock"></i> 1 Hour</span>
                                <span><i className="fa fa-wifi"></i> Beginner</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3">
                    <div className="course-box">
                        <div className="course-img">
                            <img src={python_img} alt="Python Image" />
                        </div>
                        <div className="course-box-content">
                            <h5>Technology</h5>
                            <h4><Link to="/coursesdetailpage"> Basics of Python </Link></h4>
                            <div className="course-hour-box">
                                <span><i className="fa fa-clock"></i> 1 Hour</span>
                                <span><i className="fa fa-wifi"></i> Beginner</span>
                            </div>
                        </div>
                    </div>
                </div> */}
        </div>
      </div>
    </div>
  );
}

export default CoursesBoxes;
